<template>
  <div :class="`stats-card ${className}`">
    <span class="title">{{ title }}</span>
    <span class="primary-stat">{{ primaryStat }}</span>
    <div class="data-row">
      <span class="item">{{ masks }} </span>
      <span class="name">Masks | </span>

      <span class="item">{{ caps + other }} </span>
      <span class="name">Other</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "StatsCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    ...mapState(["global"]),
  },
  data() {
    return { primaryStat: 0, masks: 0, caps: 0 };
  },
  mounted() {
    let data =
      this.type === "outstanding"
        ? this.global.totalStats.outstanding
        : this.global.totalStats.complete;

    this.primaryStat =
      parseInt(data.masks) + parseInt(data.caps) + parseInt(data.other);
    this.masks = parseInt(data.masks);
    this.caps = parseInt(data.caps);
    this.other = parseInt(data.other);
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.stats-card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  width: 250px;
  max-width: 100%;
  background: #ffffff;
  margin: 25px 25px 0 0;
  padding: 20px 15px;
  border-radius: 5px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  z-index: 2;
  @media (max-width: $sm) {
    margin: 25px auto;
  }
  .title {
    font-size: 14px;
    font-weight: 700;
    color: #8b8795;
    letter-spacing: 0;
    text-align: right;
    border-bottom: 1px #efefef solid;
    padding-bottom: 6px;
    width: 100%;
  }
  .primary-stat {
    font-size: 33px;
    color: #ff9922;
    letter-spacing: 0;
    text-align: right;
    padding: 15px 0;
  }
  .data-row {
    border-top: 1px #efefef solid;
    width: 100%;
    text-align: right;
    .item {
      font-size: 14px;
      color: #ff9922;
      letter-spacing: 0;
    }
    .name {
      font-size: 14px;
      color: #8b8795;
      letter-spacing: 0;
      text-align: right;
    }
  }
}
</style>